import {
  type PerspectiveCamera,
  type Scene,
  Vector2,
  type WebGLRenderer,
  WebGLRenderTarget
} from "three";

export async function renderCargoSceneImage(
  renderer: WebGLRenderer,
  scene: Scene,
  camera: PerspectiveCamera
) {
  const size = renderer.getDrawingBufferSize(new Vector2());
  const width = Math.max(Math.floor(size.x), 1);
  const height = Math.max(Math.floor(size.y), 1);
  const renderTarget = new WebGLRenderTarget(width, height, {
    samples: Math.min(4, renderer.capabilities.maxSamples)
  });
  renderTarget.texture.colorSpace = renderer.outputColorSpace;
  const previousRenderTarget = renderer.getRenderTarget();

  try {
    renderer.setRenderTarget(renderTarget);
    renderer.clear();
    renderer.render(scene, camera);
    const pixels = new Uint8Array(width * height * 4);
    await renderer.readRenderTargetPixelsAsync(renderTarget, 0, 0, width, height, pixels);
    return createPngBlob(flipPixelRows(pixels, width, height), width, height);
  } finally {
    renderer.setRenderTarget(previousRenderTarget);
    renderTarget.dispose();
  }
}

export function flipPixelRows(
  pixels: Uint8Array<ArrayBufferLike>,
  width: number,
  height: number
): Uint8ClampedArray<ArrayBuffer> {
  const rowLength = width * 4;
  const flipped = new Uint8ClampedArray(new ArrayBuffer(pixels.length));
  for (let sourceRow = 0; sourceRow < height; sourceRow += 1) {
    const targetRow = height - sourceRow - 1;
    flipped.set(
      pixels.subarray(sourceRow * rowLength, (sourceRow + 1) * rowLength),
      targetRow * rowLength
    );
  }
  return flipped;
}

function createPngBlob(pixels: Uint8ClampedArray<ArrayBuffer>, width: number, height: number) {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("当前浏览器无法创建场景图片");
  }
  context.putImageData(new ImageData(pixels, width, height), 0, 0);

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
      } else {
        reject(new Error("场景图片编码失败"));
      }
    }, "image/png");
  });
}
